import axios from "axios";
import { MixpanelTracking } from "../MixPanel";
import { MixPanelConstants } from "../constants/MixPanelEvents";
import { restrictedLoggingEndPoints } from "../constants/api-endpoints";

axios.defaults.xsrfCookieName = 'csrftoken'
axios.defaults.xsrfHeaderName = 'X-CSRFTOKEN'
axios.defaults.timeout = 8000
axios.defaults.timeoutErrorMessage = 'timeout'
axios.defaults.baseURL = process.env.NEXT_PUBLIC_SERVER_BASE_URL

const logInMixPanel = (url : string, data : any) => {   
    if(restrictedLoggingEndPoints.indexOf(url) !== -1) {        
        let payload = {...data}
        for(var member in payload) 
            delete payload[member] 
        payload['message'] = 'Protected Data. Contains User password!'
        MixpanelTracking.getInstance().apiCalled(payload);
    }
    else
        MixpanelTracking.getInstance().apiCalled(data);
}

const Axios = {
    // AXIOS GET REQUEST
    requestGET : async (url : string, params : any, headers : any, successResponse : any, errorResponse : any) => {

        const mixPanelData : any = {
            endpoint : url,
            type : 'GET',
            query : params
        }

        axios.get(
            url, {
                params : params,
                headers : headers
            }, 
        ).then(response => {
            if(successResponse)
                successResponse(response);
            
            mixPanelData['status'] = MixPanelConstants.SUCCESS
            mixPanelData['response'] = response.data

            logInMixPanel(url, mixPanelData);
        }).catch(error => {
            if(errorResponse)
                errorResponse(error)
            
            mixPanelData['status'] = MixPanelConstants.FAILED
            mixPanelData['response'] = error.response
            logInMixPanel(url, mixPanelData);
        })
    },

    // AXIOS POST REQUEST
    requestPOST : (url : string, params : any, headers : any, successResponse : any, errorResponse : any, query : any = {}) => {
        const mixPanelData : any = {
            endpoint : url,
            type : 'POST',
            payload : params
        }

        axios.post(
            url, params, { headers : headers, params : query }
        ).then(response => {
            if(successResponse)
                successResponse(response);
            
            mixPanelData['status'] = MixPanelConstants.SUCCESS
            mixPanelData['response'] = response.data
            
            logInMixPanel(url, mixPanelData);
        }).catch(error => {
            if(errorResponse)
                errorResponse(error)
            
            mixPanelData['status'] = MixPanelConstants.FAILED
            mixPanelData['response'] = error.response
            logInMixPanel(url, mixPanelData);
        })
    },

    // AXIOS PUT REQUEST
    requestPUT : (url : string, params : any,  headers : any, successResponse : any, errorResponse : any) => {
        const mixPanelData : any = {
            endpoint : url,
            type : 'PUT',
            payload : params
        }

        axios.put(
            url, params, { headers : headers }
        ).then(response => {
            if(successResponse)
                successResponse(response);
            
            mixPanelData['status'] = MixPanelConstants.SUCCESS
            mixPanelData['response'] = response.data

            logInMixPanel(url, mixPanelData);
        }).catch(error => {
            if(errorResponse)
                errorResponse(error)
            
            mixPanelData['status'] = MixPanelConstants.FAILED
            mixPanelData['response'] = error.response

            logInMixPanel(url, mixPanelData);
        })
    },

    // AXIOS PATCH REQUEST
    requestPATCH : (url : string, params : any,  headers : any, successResponse : any, errorResponse : any) => {
        const mixPanelData : any = {
            endpoint : url,
            type : 'PATCH',
            payload : params
        }

        axios.patch(
            url, params, { headers : headers }
        ).then(response => {
            if(successResponse)
                successResponse(response);
            
            mixPanelData['status'] = MixPanelConstants.SUCCESS
            mixPanelData['response'] = response.data

            logInMixPanel(url, mixPanelData);
        }).catch(error => {
            if(errorResponse)
                errorResponse(error)
            
            mixPanelData['status'] = MixPanelConstants.FAILED
            mixPanelData['response'] = error.response

            logInMixPanel(url, mixPanelData);
        })
    },

}

// ASYNCHRONOUS CALLS
export const AxiosPromise = {
    
    // AXIOS ASYNC GET REQUEST
    requestGET : async (url : string, params : any, headers : any, successResponse : any, errorResponse : any, additionalOptions : any = {}) => {
        const mixPanelData : any = {
            endpoint : url,
            type : 'GET',
            query : params
        }

        try {
            const response = await axios.get(url, {
                params : params,
                headers : headers,
                ...additionalOptions
            });       
            successResponse(response);

            mixPanelData['status'] = MixPanelConstants.SUCCESS
            mixPanelData['response'] = response.data

            logInMixPanel(url, mixPanelData);
        }

        catch(error : any) {
            console.log(error);
            if(errorResponse) 
                errorResponse(error)
            
            mixPanelData['status'] = MixPanelConstants.FAILED
            mixPanelData['response'] = error.response
            logInMixPanel(url, mixPanelData);
        }
    },

    // AXIOS ASYNC POST REQUEST
    requestPOST : async (url : string, params : any, headers : any, successResponse : any, errorResponse : any, query : any = {}) => {

        const mixPanelData : any = {
            endpoint : url,
            type : 'POST',
            payload : params
        }

        try {
            const response = await axios.post(url, params, { 
                headers : headers,
                params : query
            });       
            successResponse(response);

            mixPanelData['status'] = MixPanelConstants.SUCCESS
            mixPanelData['response'] = response.data

            logInMixPanel(url, mixPanelData);
        }
        catch(error : any) {
            console.log(error);
            if(errorResponse) 
                errorResponse(error);
            
            mixPanelData['status'] = MixPanelConstants.FAILED
            mixPanelData['response'] = error.response
            logInMixPanel(url, mixPanelData);
        }
    },

    // AXIOS ASYNC PUT REQUEST
    requestPUT : async (url : string, params : any,  headers : any, successResponse : any, errorResponse : any) => {
        const mixPanelData : any = {
            endpoint : url,
            type : 'PUT',
            payload : params
        }

        try {
            const response = await axios.put(url, params, { headers : headers });       
            successResponse(response);

            mixPanelData['status'] = MixPanelConstants.SUCCESS
            mixPanelData['response'] = response.data

            logInMixPanel(url, mixPanelData);
        }
        catch(error : any) {
            console.log(error);
            if(errorResponse) 
                errorResponse(error);
            
            mixPanelData['status'] = MixPanelConstants.FAILED
            mixPanelData['response'] = error.response
            logInMixPanel(url, mixPanelData);
        }
    },

    // AXIOS ASYNC PATCH REQUEST
    requestPATCH : async (url : string, params : any,  headers : any, successResponse : any, errorResponse : any) => {
        const mixPanelData : any = {
            endpoint : url,
            type : 'PATCH',
            payload : params
        }

        try {
            const response = await axios.patch(url, params, { headers : headers });       
            successResponse(response);

            mixPanelData['status'] = MixPanelConstants.SUCCESS
            mixPanelData['response'] = response.data

            logInMixPanel(url, mixPanelData);
        }
        catch(error : any) {
            console.log(error);
            if(errorResponse) 
                errorResponse(error)
            
            mixPanelData['status'] = MixPanelConstants.FAILED
            mixPanelData['response'] = error.response
            logInMixPanel(url, mixPanelData);
        }
    },
}

export default Axios;